(function () {
  var messages = document.querySelectorAll('.announcement-bar__message');

  messages.forEach(function (message) {
    if (message.dataset.marqueeReady) return;
    message.dataset.marqueeReady = 'true';

    var track = document.createElement('div');
    track.className = 'announcement-marquee__track';

    var original = document.createElement('div');
    original.className = 'announcement-marquee__item';
    original.innerHTML = message.innerHTML;
    track.appendChild(original);

    message.innerHTML = '';
    message.appendChild(track);
    message.classList.add('announcement-marquee');

    function fillTrack() {
      while (track.children.length > 1) {
        track.removeChild(track.lastChild);
      }
      var itemWidth = original.getBoundingClientRect().width;
      if (!itemWidth) return;
      var containerWidth = message.getBoundingClientRect().width;
      var minWidth = containerWidth * 2 + itemWidth;
      var neededClones = Math.min(Math.ceil(minWidth / itemWidth), 60);
      var fragment = document.createDocumentFragment();
      for (var i = 1; i < neededClones; i++) {
        var clone = original.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        fragment.appendChild(clone);
      }
      track.appendChild(fragment);
      track.style.setProperty('--marquee-item-width', itemWidth + 'px');
    }

    fillTrack();

    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(fillTrack, 150);
    });
  });
})();
